// extracted by mini-css-extract-plugin
export default {"tensorflow":"tensorflow_tensorflow__BlPur","cam":"tensorflow_cam__KOj3n","class":"tensorflow_class__FJbnE"};